import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common';

const states: Ng1StateDeclaration[] = [
    {
        name: 'editSendMailAction',
        url: '/editSendMailAction/:actionGuid',
        component: 'wtEditSendMailActionState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer])
        },
        data: {
            backButtonDisabled: () => false,
            backButtonVisibility: () => true,
            displayName: 'Edit Email',
            editButtonDisabled: () => true,
            editButtonVisibility: () => true,
            editRoles: [Roles.administrator, Roles.master, Roles.engineer],
            icon: '',
            sortingOrder: -1
        },
        params: {
            origin: 'triggerAction'
        }
    }];

export default states;